import {
  GetReviewsRequest,
  GetReviewsResponseDto,
} from '@bitecritic-api/src/reviews/dto/get-reviews.dto';
import { ReviewCreateDTO } from '@bitecritic-api/src/reviews/dto/review.dto';
import requestService from '../requestsService/requests.service';
import {
  GetFeedRequest,
  GetFeedResponse,
} from '@bitecritic-api/src/reviews/dto/get-feed.dto';
import { ReviewResponseDto } from '@bitecritic-api/src/reviews/dto/review.response.dto';

const basePath = '/reviews' as const;

async function getReviews(
  params: GetReviewsRequest,
): Promise<GetReviewsResponseDto> {
  const searchParams = new URLSearchParams();

  // Filter out undefined values and add remaining params to search params
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });

  const response = await requestService.fetch<GetReviewsResponseDto>(
    `${basePath}?${searchParams.toString()}`,
  );
  if (!response) {
    throw new Error('Failed to fetch reviews');
  }
  return response;
}

async function createReview(data: ReviewCreateDTO): Promise<ReviewResponseDto> {
  return requestService.post(basePath, data);
}

async function getReviewById(
  id: string,
  language?: string,
): Promise<ReviewResponseDto> {
  const response = await requestService.fetch<ReviewResponseDto>(
    `${basePath}/${id}`,
    {
      qs: {
        language,
        includeTranslations: 'true',
      },
    },
  );

  if (!response) {
    throw new Error('Failed to fetch review');
  }
  return response;
}

async function getReviewsByUserId(
  userId: string,
): Promise<ReviewResponseDto[]> {
  const response = await requestService.fetch<ReviewResponseDto[]>(
    `${basePath}/user/${userId}`,
  );

  if (!response) {
    throw new Error('Failed to fetch reviews');
  }
  return response;
}

async function updateLikeCount(
  reviewId: string,
  increment: number,
): Promise<number> {
  return requestService.patch(`${basePath}/${reviewId}/like`, { increment });
}

async function deleteReview(id: string): Promise<ReviewResponseDto> {
  return requestService.delete(`${basePath}/${id}`);
}

export const getFeed = async (
  params: GetFeedRequest,
): Promise<GetFeedResponse> => {
  const response = await requestService.fetch<GetFeedResponse>(
    `${basePath}/feed`,
    { qs: params },
  );
  if (!response) {
    throw new Error('Failed to fetch feed');
  }
  return response;
};

export const reviewsService = {
  getReviews,
  createReview,
  getReviewById,
  getReviewsByUserId,
  updateLikeCount,
  deleteReview,
  getFeed,
};
